import { render, staticRenderFns } from "./AdminImport.vue?vue&type=template&id=0dc6c804&scoped=true"
import script from "./AdminImport.vue?vue&type=script&lang=js"
export * from "./AdminImport.vue?vue&type=script&lang=js"
import style0 from "./AdminImport.vue?vue&type=style&index=0&id=0dc6c804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6c804",
  null
  
)

export default component.exports